<template>
  <div
    class="container-fluid"
    style="padding: 0; margin: 0; width: 100vw"
    id="container_login"
  >
    <div class="row">
      <div class="col" style="padding: 0">
        <div class="container-fluid">
          <div
            class="row"
            id="section1"
            :style="`background-image:url(${
              esDemo
                ? 'https://lmsedk.com/site_new/assets/images/slider/3.png'
                : '/static/assetsTernium/img/bg1.jpg'
            })`"
          >
            <div class="container-fluid">
              <div class="row" id="contentTOP">
                <div class="container-fluid">
                  <div class="row justify-content-md-center" id="parentHeaders">
                    <div
                      class="col-lg-3 col-md-4 col-sm-5 col-xs-4"
                      id="header1"
                    >
                      <img
                        :src="
                          esDemo
                            ? 'https://lmsedk.com/site_v3/img/logo.png'
                            : '/static/assetsTernium/LogoTernium.png'
                        "
                        alt="Logo Ternium"
                        id="imgLogoTernium"
                      />
                    </div>
                    <div
                      class="col-lg-8 col-md-7 col-sm-7 col-xs-8"
                      id="header2"
                    >
                      <span
                        class="spanHeader"
                        @click="
                          () => {
                            $router.push({ name: 'FAQ' });
                          }
                        "
                        >FAQ</span
                      >
                      <span class="spanHeader">Requerimientos de software</span>
                      <span class="spanHeader">Contáctenos</span>
                    </div>
                  </div>
                  <div class="row justify-content-md-center" id="subHeader">
                    <div class="col-auto contenedorTitulosLogin">
                      <div class="box container-fluid">
                        <div class="top"></div>
                        <div class="bottom"></div>
                        <div class="left"></div>
                        <div class="right"></div>
                        <div class="row titleLoginContainer">
                          <h1>Capacitación Contratistas</h1>
                        </div>
                      </div>
                      <div class="auth-box" v-bind:class="result">
                        <div
                          v-if="mostrar1"
                          id="recoverform"
                          class="contenedorLogin"
                        >
                          <div id="contentSpanIngreseCuenta">
                            <h5 id="spanIngreseCuenta" class="">
                              Recuperar Contraseña
                            </h5>
                            <div class="container">
                              <div class="row">
                                <span id="spanIngreseCuentaTexto"
                                  >Ingresa tu email y CURP para enviarte las
                                  instrucciones!</span
                                >
                              </div>
                              <div class="row">
                                <span id="spanIngreseCuentaTexto"
                                  >Si eres un representante de empresa, debes
                                  ingresar tu ID de empresa y tu email.</span
                                >
                              </div>
                            </div>
                          </div>
                          <!-- Form -->
                          <form
                            class="col-12"
                            v-on:submit.prevent="recuperarContrasena"
                          >
                            <!-- email -->
                            <div class="container-fluid" id="loginDiv">
                              <div
                                class="row"
                                style="
                                  padding-left: 10%;
                                  padding-right: 10%;
                                  padding-bottom: 30px;
                                "
                              >
                                <input
                                  class="textLoginPlaceholder"
                                  type="text"
                                  required
                                  placeholder="Email"
                                  style="box-shadow: none"
                                  title="Email"
                                  v-model="emailRC"
                                />
                                <h6>
                                  <small
                                    v-if="validacionCorreo"
                                    style="color: white"
                                    >El CORREO ingresado es incorrecto</small
                                  >
                                </h6>
                              </div>
                              <!-- CURP -->
                              <div
                                class="row"
                                style="
                                  padding-left: 10%;
                                  padding-right: 10%;
                                  padding-bottom: 30px;
                                "
                              >
                                <input
                                  class="textLoginPlaceholder"
                                  type="text"
                                  required
                                  placeholder="CURP / ID empresa"
                                  style="box-shadow: none"
                                  title="Curp"
                                  v-model="curpRC"
                                />
                                <h6>
                                  <small
                                    v-if="validacionCurp"
                                    style="color: white"
                                    >El CURP ingresado es incorrecto</small
                                  >
                                </h6>
                              </div>
                              <!-- pwd -->
                              <div class="row">
                                <div
                                  class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
                                  style="padding: 0px; padding-left: 10%"
                                >
                                  <button
                                    class="btn btnFullWhite"
                                    type="submit"
                                  >
                                    Enviar
                                  </button>
                                </div>
                                <div
                                  class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
                                  style="padding: 0px; padding-left: 5%"
                                >
                                  <button
                                    class="btn btnFullWhite"
                                    type="submit"
                                    v-on:click.prevent="regresarInicio"
                                  >
                                    Regresar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div
                          v-if="mostrar"
                          class="contenedorLogin"
                          id="loginform"
                        >
                          <div class="row" id="contentSpanIngreseCuenta">
                            <span id="spanIngreseCuenta"
                              >Ingresa a tu cuenta</span
                            >
                          </div>
                          <form
                            v-on:submit.prevent="Iniciar_Sesion"
                            id="loginform"
                          >
                            <input
                              name="__RequestVerificationToken"
                              type="hidden"
                              value="OHTz5bDiUfoY-GO10HHFKstq3fbeyWBQhqgUAgRijKwYs8i3pTSX04CYPdC9kYo-b0JU53PK2TF_LyQeHN41G-76HE2c65CP7rT0ovAU7Uo1"
                            />
                            <div
                              v-if="esDemo"
                              class="row"
                              style="
                                padding-left: 10%;
                                padding-right: 10%;
                                padding-bottom: 10px;
                              "
                            >
                              <div class="form-group w-100">
                                <select
                                  class="
                                    form-control
                                    textLoginPlaceholder
                                    custom-select
                                  "
                                  v-model="clienteDemo"
                                  id="clienteFormControlSelect"
                                >
                                  <option
                                    class="
                                      textLoginPlaceholder
                                      optionLoginSelector
                                      active
                                    "
                                    value="null"
                                  >
                                    <h3>--SELECCIONA TU ENTIDAD--</h3>
                                  </option>
                                  <option
                                    class="
                                      textLoginPlaceholder
                                      optionLoginSelector
                                    "
                                    v-for="(cliente, index) in clientesDemo"
                                    :key="'cliente' + index"
                                    :value="cliente.cve_cliente"
                                  >
                                    {{ cliente.nombre_cliente }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div
                              class="row"
                              style="
                                padding-left: 10%;
                                padding-right: 10%;
                                padding-bottom: 30px;
                              "
                            >
                              <input
                                class="textLoginPlaceholder"
                                required
                                id="UserName"
                                name="UserName"
                                placeholder="CPF - CURP - CUI"
                                style="box-shadow: none"
                                type="text"
                                value=""
                                title="Nombre de Usuario"
                                v-model="usuario"
                              />
                            </div>
                            <div
                              class="row d-flex flex-row"
                              style="
                                padding-left: 10%;
                                padding-right: 10%;
                                padding-bottom: 30px;
                              "
                            >
                              <input
                                class="textLoginPlaceholder1"
                                required
                                id="Password"
                                name="Password"
                                placeholder="Contraseña"
                                style="box-shadow: none"
                                type="password"
                                title="Contraseña"
                                v-model="password"
                              />
                              <button
                                class="btn"
                                type="button"
                                id="btn_Mostrar_Password"
                                @click="mostrarContrasena"
                              >
                                <i :class="icono_Pass"></i>
                              </button>
                            </div>
                            <div class="row align-items-center">
                              <div
                                class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
                                style="padding: 0px; padding-left: 10%"
                              >
                                <button
                                  type="submit"
                                  class="btn btnFullWhite"
                                  style="width: 105px"
                                  id="btnIngresar"
                                >
                                  Ingresar
                                </button>
                              </div>
                              <div class="col" style="height: fit-content">
                                <div class="container">
                                  <div class="row justify-content-center">
                                    <div
                                      class="col-auto"
                                      style="
                                        padding-left: 0px;
                                        padding-right: 0px;
                                        text-align: center;
                                        color: white;
                                      "
                                    >
                                      <a
                                        id="to-recover"
                                        class="spanLinkLogin"
                                        v-on:click.prevent="recoverPassword"
                                        >¿Olvidaste tu contraseña?</a
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div
                              class="row"
                              style="margin-top: 3%; padding-left: 10%"
                            >
                              <div
                                class="col-11"
                                style="
                                  padding-left: 1em;
                                  padding-right: 0px;
                                  text-align: initial;
                                  color: white;
                                "
                              >
                                <a id="problemasLOGIN" class="spanLinkLogin"
                                  >¿tienes problemas para ingresar? <br />
                                  comunicate con tu representante de empresa</a
                                >
                              </div>
                            </div>
                          </form>
                        </div>
                        <RestablecerUsuario
                          v-if="mostrar2"
                          :token="tokenRest"
                          @regresar="regresarInicio2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-white"></div>
          <div class="row contenedorMainFunctions" v-if="!esDemo">
            <div
              class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
              style="padding: 0"
            >
              <div class="row" style="padding: 3% 0 3% 3%">
                <h5 id="spanFuncionesPrincipales">Te damos la bienvenida</h5>
              </div>
              <div
                class="col-lg-10 col-md-10 col-sm-12 col-xs-12"
                style="padding: 3%"
              >
                <span
                  class="subtitulos2"
                  id="spanAhoraDesde"
                  style="line-height: 25px; display: block"
                  >Una plataforma de formación diseñada para las compañías
                  contratistas que trabajan con Ternium. Encuentra aquí cursos
                  en línea, videos y más para cumplir con la capacitación
                  necesaria de acuerdo con tu rol.</span
                >
              </div>
            </div>
            <div
              class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
              style="text-align: right"
            >
              <img
                src="/static/assetsTernium/img/mosaico.png"
                alt="Webservice Mobile"
                style="
                  width: 100%;
                  border-radius: 5px;
                  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.09);
                "
              />
            </div>
          </div>
          <div class="row contenedorConfiguracion" v-if="!esDemo">
            <div class="row" style="padding-left: 0px; padding-right: 0px">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText">
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5Multiplataforma"
                  >
                    Lorem ipsum dolor sit
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanMultiplataforma"
                    >Lorem ipsum dolor sit amet consectetur adipiscing, elit
                    fringilla accumsan mi nulla et consequat, ornare eros
                    gravida mauris molestie. Ligula dapibus condimentum massa
                    placerat ridiculus, commodo urna vestibulum odio risus,
                    dignissim purus nulla fermentum.</span
                  >
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText">
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5Documentos"
                  >
                    Lorem ipsum dolor sit
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanDocumentos"
                    >Lorem ipsum dolor sit amet consectetur adipiscing, elit
                    fringilla accumsan mi nulla et consequat, ornare eros
                    gravida mauris molestie. Ligula dapibus condimentum massa
                    placerat ridiculus, commodo urna vestibulum odio risus,
                    dignissim purus nulla fermentum.</span
                  >
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText">
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5Notificaciones"
                  >
                    Lorem ipsum dolor sit
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanNotificaciones"
                    >Lorem ipsum dolor sit amet consectetur adipiscing, elit
                    fringilla accumsan mi nulla et consequat, ornare eros
                    gravida mauris molestie. Ligula dapibus condimentum massa
                    placerat ridiculus, commodo urna vestibulum odio risus,
                    dignissim purus nulla fermentum.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="row"
              style="
                padding-left: 0px;
                padding-right: 0px;
                margin-top: 5%;
                margin-bottom: 2%;
              "
            >
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText">
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5ConfigurarTablas"
                  >
                    Lorem ipsum dolor sit
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanConfigurarTablas"
                    >Lorem ipsum dolor sit amet consectetur adipiscing, elit
                    fringilla accumsan mi nulla et consequat, ornare eros
                    gravida mauris molestie. Ligula dapibus condimentum massa
                    placerat ridiculus, commodo urna vestibulum odio risus,
                    dignissim purus nulla fermentum.</span
                  >
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText">
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5RestreoOrden"
                  >
                    Lorem ipsum dolor sit
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanRastreoOrden"
                    >Lorem ipsum dolor sit amet consectetur adipiscing, elit
                    fringilla accumsan mi nulla et consequat, ornare eros
                    gravida mauris molestie. Ligula dapibus condimentum massa
                    placerat ridiculus, commodo urna vestibulum odio risus,
                    dignissim purus nulla fermentum.</span
                  >
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText">
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5SeguimientoEntrega"
                  >
                    Lorem ipsum dolor sit
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanSeguimientoEntrega">
                    Lorem ipsum dolor sit amet consectetur adipiscing, elit
                    fringilla accumsan mi nulla et consequat, ornare eros
                    gravida mauris molestie. Ligula dapibus condimentum massa
                    placerat ridiculus, commodo urna vestibulum odio risus,
                    dignissim purus nulla fermentum.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid backgroundNegro" v-if="!esDemo">
            <div class="row" style="margin: 3vh; margin-left: 0px; padding: 0">
              <h5 class="ventajas" id="h5Ventas">Ventajas</h5>
            </div>
            <div class="row" style="margin-top: 5vh; padding: 0">
              <div
                class="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                style="padding-right: 40px"
              >
                <span
                  class="subtitulos"
                  id="spanOrdenes"
                  style="position: absolute"
                  >Órdenes</span
                >
                <h5 class="textoAdvantages">01</h5>
                <span class="body3" id="spanSubOrdenes"
                  >Puede seguir el estado de su solicitud de material.</span
                >
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                style="padding-right: 40px"
              >
                <span
                  class="subtitulos"
                  id="spanStock"
                  style="position: absolute"
                  >Stock</span
                >
                <h5 class="textoAdvantages">02</h5>
                <span class="body3" id="spanSubStock"
                  >Puedes ver tu stock disponible en cualquier momento.</span
                >
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                style="padding-right: 40px"
              >
                <span
                  class="subtitulos"
                  id="spanEmbarque"
                  style="position: absolute"
                  >Despachos</span
                >
                <h5 class="textoAdvantages">03</h5>
                <span class="body3" id="spanSubEmbarque"
                  >Se podrán consultar las entregas ya efectuadas revisando a
                  detalle el contenido de los materiales enviados.</span
                >
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                style="padding-right: 0"
              >
                <span
                  class="subtitulos"
                  id="spanNotificacionesFooter"
                  style="position: absolute"
                  >Notificaciones</span
                >
                <h5 class="textoAdvantages">04</h5>
                <span class="body3" id="spanSubNotificacionesFooter"
                  >Te hacemos llegar todos los datos de los eventos relevantes
                  en el momento en que suceden.</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container-fluid contenedorFooter"
      v-if="!esDemo"
      style="width: 100%; padding: 2%"
    >
      <div class="row" style="padding-left: 3%; margin-top: 2%">
        <div
          class="col-lg-7 col-md-5 col-sm-12 col-xs-12"
          style="
            padding-left: 0px;
            line-height: 48px;
            text-align: left;
            padding-right: 0;
          "
        >
          <span
            class="spanPreguntasFrecuentesL spanFooter"
            style="margin-right: 20px"
            >FAQ</span
          >
          <span
            class="spanRequerimientosdeSoftwareL spanFooter"
            style="margin-right: 20px"
            >Requerimientos de software</span
          >
          <span class="spanContactenosL spanFooter">Contáctenos</span>
        </div>
        <div
          class="
            col-lg-4 col-md-5 col-sm-8 col-md-offset-0 col-sm-offset-4 col-xs-12
          "
          style="padding-left: 0px; text-align: right"
        >
          <span
            style="
              display: inline-block;
              color: rgba(255, 255, 255, 0.3);
              line-height: 50px;
              cursor: initial;
              font-size: 14px;
              font-family: 'Trade Gothic LT';
            "
            >Copyright 2021 Ternium</span
          >
          <img
            class="logoNegroTernium"
            src="/static/assetsTernium/img/iconoNegro.png"
            alt="Logo Negro Ternium"
            style="margin-left: 40px"
          />
          <span
            style="
              color: rgba(255, 255, 255, 0.3);
              line-height: 50px;
              cursor: initial;
              font-size: 14px;
              font-family: 'Trade Gothic LT';
              position: absolute;
              width: fit-content;
              height: 1em;
              top: 3em;
              right: 1em;
            "
            id="textMARK"
            >powered by LMSEDK®</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode";
import { mapActions } from "vuex";
import RestablecerUsuario from "./RestablecerUsuario.vue";

export default {
  components: { RestablecerUsuario },
  data() {
    return {
      clienteDemo: null,
      clientesDemo: [],
      usuario: "",
      password: "",
      password1: "",
      emailRC: "",
      curpRC: "",
      clientes: [],
      clientes_autocomplete: [],
      token: this.$route.params.jwt,
      result: "d-none",
      bandera: false,
      classPass: "is-invalid",
      classPass1: "is-invalid",
      mostrar: true,
      mostrar1: false,
      mostrar2: false,
      tokenRest: "",
      validacionCorreo: false,
      validacionCurp: false,
      icono_Pass: "fas fa-eye",
      reglas: [
        {
          text: "Longitud de contraseña: minimo 8 caracteres",
          isValid: (value) => {
            if (value.length >= 8) {
              return true;
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres numericos: minimo 2 numeros",
          isValid: (value) => {
            let bandera = 0;
            for (let i = 0; i < value.length; i++) {
              if (/^[0-9]+$/.test(value.charAt(i))) {
                bandera++;
                if (bandera == 2) {
                  return true;
                }
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres de simbolos: minimo 1 caracter especial",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (!/[a-zA-Z0-9]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras mayúsculas: minimo 1 letra mayúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[A-Z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras minúsculas: minimo 1 letra minúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[a-z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
      ],
    };
  },
  methods: {
    mostrarContrasena() {
      var tipo = document.getElementById("Password");
      if (tipo.type == "password") {
        tipo.type = "text";
        this.icono_Pass = "fas fa-eye-slash";
      } else {
        tipo.type = "password";
        this.icono_Pass = "fas fa-eye";
      }
    },
    recuperarContrasena() {
      let that = this;
      let data = VueJwtDecode.decode(this.token).data;
      let bandera = false;
      let bandera1 = false;

      if (
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
          this.emailRC
        )
      ) {
        bandera = true;
        this.validacionCorreo = false;
      } else {
        this.validacionCorreo = true;
      }

      if (/^([a-zA-Z0-9_-]){1,100}$/.test(this.curpRC)) {
        if (this.curpRC.indexOf("-", 0) == -1) {
          if (this.curpRC.indexOf("_", 0) == -1) {
            bandera1 = true;
            this.validacionCurp = false;
          } else {
            this.validacionCurp = true;
          }
        } else {
          this.validacionCurp = true;
        }
      } else {
        this.validacionCurp = true;
      }

      if (bandera && bandera1) {
        this.$http
          .post("usuarios/restablecerContrasena", {
            email: this.emailRC,
            curp: this.curpRC,
          })
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            if (respuestaJson.resp == "Excelente") {
              swal(
                respuestaJson.resp,
                "Hemos enviado a tu correo las instrucciones para tu cambio de contraseña",
                "success"
              );
              setTimeout(() => {
                that.regresarInicio();
              }, 1500);
            } else {
              that.Listo();
              swal("!Ups¡", respuestaJson.resp, "error");
            }
          })
          .catch(function (error) {
            console.log("Error en Restablecer_Contraseña", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            that.Listo();
          });
        that.Listo();
      }
    },
    enviarNuevasCredenciales() {
      let that = this;
      let data = VueJwtDecode.decode(this.token).data;
      if (
        this.password === this.password1 &&
        this.password != data.cve_empleado
      ) {
        this.$http
          .post("usuarios/restablecerUsuario", {
            password: this.password,
            cve_empleado: data.cve_empleado,
          })
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            if (respuestaJson.resp == "Excelente") {
              swal(respuestaJson.resp, "Usuario actualizado", "success");
              setTimeout(() => {
                that.$router.push({ name: "Login" });
              }, 1500);
            } else {
              that.Listo();
              swal("!Ups¡", respuestaJson.resp, "error");
            }
          })
          .catch(function (error) {
            console.log("Error en Iniciar_Sesion", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            that.Listo();
          });
      } else {
        if (this.password == data.cve_empleado) {
          swal(
            "Error de datos",
            "Favor de revisar que la contraseña no sea igual al numero de usuario: " +
              data.cve_empleado,
            "error"
          );
        } else {
          swal(
            "Error de datos",
            "Favor de revisar que las contraseñas coincidan",
            "error"
          );
        }
        that.Listo();
      }
    },
    changePass() {
      this.mostrar = false;
      this.mostrar2 = true;
    },

    regresarInicio() {
      this.mostrar = true;
      this.mostrar1 = false;
      this.validacionCorreo = false;
      this.validacionCurp = false;
    },
    regresarInicio2() {
      this.mostrar2 = false;
      this.mostrar = true;
    },
    recoverPassword() {
      this.mostrar = false;
      this.mostrar1 = true;
    },
    Cargando() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").show();
        that.result = "d-none";
      });
    },
    Listo() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").hide();
        that.result = "";
      });
    },
    async Iniciar_Sesion() {
      var that = this;
      let aprobado = false;
      this.Cargando();
      let httpEl = {};
      if (this.esDemo) {
        if (this.clienteDemo != null) {
          aprobado = true;
          httpEl = {
            navegador: this.menu.navegador,
            sistema_operativo: this.menu.sistema_operativo,
            empresa: this.empresa,
            usuario: this.usuario,
            password: this.password,
            tokenfcm: this.firebase_config.tokenfcm,
            clienteDemo: this.clienteDemo,
          };
        }
      } else {
        aprobado = true;
        httpEl = {
          navegador: this.menu.navegador,
          sistema_operativo: this.menu.sistema_operativo,
          empresa: this.empresa,
          usuario: this.usuario,
          password: this.password,
          tokenfcm: this.firebase_config.tokenfcm,
        };
      }

      if (aprobado) {
        this.$http
          .post("login", httpEl)
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            var pasar = "Si";

            if (respuestaJson.resp == "Excelente") {
              var usuario_datos = VueJwtDecode.decode(respuestaJson.jwt);
              console.log(usuario_datos);
              this.$store.state.menu.usuario = usuario_datos.data;
              this.$store.state.menu.token = respuestaJson.jwt;
              this.Actualizar_Usuario(usuario_datos.data, respuestaJson.jwt);
              localStorage.removeItem("apiKey_lms");
              localStorage.apiKey_lms = JSON.stringify(respuestaJson.jwt);
            } else {
              if (respuestaJson.resp == "Cambio de credenciales") {
                that.tokenRest = respuestaJson.jwt;
                that.changePass();
                that.Listo();
              } else if (respuestaJson.resp.includes("ocupada")) {
                that.Listo();
                toastr.error(
                  "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
                );
                swal(
                  respuestaJson.resp,
                  "Por favor intenta mas tarde.",
                  "error"
                );
              } else {
                that.Listo();
                toastr.error(
                  "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
                );
                swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
              }
            }
          })
          .catch(function (error) {
            console.log("Error en Iniciar_Sesion", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            toastr.error(
              "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
            );
            that.Listo();
          });
      } else {
        that.Listo();
        toastr.error("Selecciona la entidad por favor");
      }
    },
    ConsultarClientes: function () {
      var that = this;
      this.Cargando();
      this.$http
        .post("clientes", {
          empresa: this.empresa,
          usuario: this.usuario,
          password: this.password,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          var pasar = "Si";

          if (respuestaJson.resp == "Excelente") {
            var usuario_datos = VueJwtDecode.decode(respuestaJson.jwt);

            this.$store.state.menu.usuario = usuario_datos.data;
            this.$store.state.menu.token = respuestaJson.jwt;
            this.Actualizar_Usuario(usuario_datos.data, respuestaJson.jwt);
            localStorage.removeItem("apiKey_lms");

            localStorage.apiKey_lms = JSON.stringify(respuestaJson.jwt);
          } else {
            that.Listo();
            swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
          }
        })
        .catch(function () {
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (3)",
            "error"
          );
          that.Listo();
        });
    },
    ConsultarClientesDemo: function () {
      var that = this;
      this.Cargando();
      this.$http
        .get("https://lmsedk.com/DEMO/api/public/pub/getClientesDemo")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.clientesDemo = respuestaJson.clientesDemo;
        })
        .catch(function () {
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (3)",
            "error"
          );
          that.Listo();
        });
    },
    Seleccionar_Empresa(nombre_empresa) {
      for (var i = 0; i < this.clientes.length; i++) {
        if (this.clientes[i].nomcliente == nombre_empresa) {
          this.Actualizar_Empresa(this.clientes[i].idcliente);
        }
      }
    },
    autocomplete(inp, arr) {
      var that = this;
      that.inp = inp;
      that.arr = arr;
      $(document).ready(function () {
        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        var currentFocus;
        /*execute a function when someone writes in the text field:*/
        that.inp.addEventListener("input", function (e) {
          var a,
            b,
            i,
            val = this.value;
          /*close any already open lists of autocompleted values*/
          that.closeAllLists();
          if (!val) {
            return false;
          }
          currentFocus = -1;
          /*create a DIV element that will contain the items (values):*/
          a = document.createElement("DIV");
          a.setAttribute("id", this.id + "autocomplete-list");
          a.setAttribute("class", "autocomplete-items");
          /*append the DIV element as a child of the autocomplete container:*/
          this.parentNode.appendChild(a);
          /*for each item in the array...*/
          for (i = 0; i < that.arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (
              that.arr[i].substr(0, val.length).toUpperCase() ==
              val.toUpperCase()
            ) {
              /*create a DIV element for each matching element:*/
              b = document.createElement("DIV");
              /*make the matching letters bold:*/
              b.innerHTML =
                "<strong>" + that.arr[i].substr(0, val.length) + "</strong>";
              b.innerHTML += that.arr[i].substr(val.length);
              /*insert a input field that will hold the current array item's value:*/
              b.innerHTML +=
                "<input type='hidden' value='" + that.arr[i] + "'>";
              /*execute a function when someone clicks on the item value (DIV element):*/
              b.addEventListener("click", function (e) {
                /*insert the value for the autocomplete text field:*/
                that.inp.value = this.getElementsByTagName("input")[0].value;
                that.Seleccionar_Empresa(
                  this.getElementsByTagName("input")[0].value
                );
                /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                that.closeAllLists();
              });
              a.appendChild(b);
            }
          }
        });
        /*execute a function presses a key on the keyboard:*/
        that.inp.addEventListener("keydown", function (e) {
          var x = document.getElementById(this.id + "autocomplete-list");
          if (x) x = x.getElementsByTagName("div");
          if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
              increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            that.addActive(x);
          } else if (e.keyCode == 38) {
            //up
            /*If the arrow UP key is pressed,
              decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            that.addActive(x);
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) x[currentFocus].click();
            }
          }
        });
        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
          that.closeAllLists(e.target);
        });
      });
    },
    addActive(x) {
      var that = this;
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      that.removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    },
    removeActive(x) {
      var that = this;
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    },
    closeAllLists(elmnt) {
      var that = this;
      /*close all autocomplete lists in the document,
      except the one passed as an argument:*/
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != that.inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    },
    Definir_Token_Generico() {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(that.token);
      this.Listo();
    },
    Validar_Token() {
      var that = this;

      if (localStorage.getItem("apiKey_lms")) {
        if (JSON.parse(localStorage.apiKey_lms).length > 100) {
          var token = VueJwtDecode.decode(JSON.parse(localStorage.apiKey_lms));

          if (token.data.cve_empleado != "Generico") {
            this.$http
              .get("usuarios/login/" + token.data.cve_empleado)
              .then((respuesta) => {
                return respuesta.json();
              })
              .then((respuestaJson) => {
                if (respuestaJson.length > 0) {
                  this.Actualizar_Usuario(
                    respuestaJson[0],
                    respuestaJson[0].token
                  );
                } else {
                  that.Definir_Token_Generico();
                }
              })
              .catch((error) => {
                that.Definir_Token_Generico();
              });
          } else {
            that.Definir_Token_Generico();
          }
        } else {
          that.Definir_Token_Generico();
        }
      } else {
        that.Definir_Token_Generico();
      }
    },
    Consultar_Token_Generico() {
      var that = this;
      this.$http
        .get("../pub/token/generico")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.token != undefined) {
            that.token = respuestaJson.token;
            that.Actualizar_TokenGenerico(that.token);
            that.Validar_Token();
          } else {
            that.Definir_Token_Generico();
            swal(
              "Problemas con el servidor",
              "Favor de intentar mas tarde",
              "error"
            );
          }
        })
        .catch((error) => {
          that.Definir_Token_Generico();
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (3)",
            "error"
          );
        });
    },
    Actualizar_Usuario(usuario, token) {
      var that = this;
      this.$store
        .dispatch("Actualizar_Usuario", { usuario: usuario, token: token })
        .then((data) => {
          that.Validar_Permisos(token);
        });
    },
    Validar_Permisos(token) {
      var that = this;
      this.$store.dispatch("Definir_Opciones_Menu_Lateral").then((data) => {
        that.Continuar_Menu(token);
      });
    },
    Continuar_Menu(token) {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(token);
      this.$router.push({ name: "Menu", params: { origin: "Login" } });
    },
    ...mapActions(["Actualizar_TokenGenerico", "Actualizar_Empresa"]),
  },
  watch: {
    clientes_autocomplete: function (newValue, oldValue) {
      var that = this;
      //that.autocomplete(document.getElementById("myInput"), that.clientes_autocomplete);
    },
    password: function () {
      this.reglas.forEach((element) => {
        if (element.isValid(this.password)) {
          element.class = "text-success";
          return element;
        } else {
          element.class = "text-danger";
          return element;
        }
      });
      let rest = this.reglas.filter((element) => {
        return !element.isValid(this.password);
      });
      if (rest.length > 0) {
        this.classPass = "is-invalid";
      }
      if (rest.length == 0) {
        this.classPass = "is-valid";
      }
    },
    password1() {
      if (this.password == this.password1) {
        this.classPass1 = "is-valid";
      } else {
        this.classPass1 = "is-invalid";
      }
    },
  },
  computed: {
    esDemo() {
      return this.$http.options.url.includes("/DEMO/api/public");
    },
    menu() {
      return this.$store.getters.getMenu;
    },
    firebase_config() {
      return this.$store.getters.getFirebase_Config;
    },
    cia() {
      return this.$store.getters.getCia;
    },
  },
  created() {
    this.Consultar_Token_Generico();
    if (this.esDemo) {
      this.ConsultarClientesDemo();
    }
    //this.ConsultarClientes();
  },
  mounted() {
    var that = this;
    $("#customizer_color_menu").addClass("d-none");
    $("#ze-snippet").remove();
    /*
    if (that.clientes_autocomplete!=null) {
      that.autocomplete(document.getElementById("myInput"), that.clientes_autocomplete);
    }
    */
  },
};
</script>

<style scoped>
/**
  ////////FAMILY FONTS//////

 */

#parentHeaders {
  padding-left: 2em;
  padding-right: 2em;
}
#header2 {
  line-height: 40px;
  height: 50px !important;
  text-align: right;
}
#imgLogoTernium {
  margin-left: 1em;
}
input[type="radio"] {
  display: none;
}
label {
  font-family: "Trade Gothic LT";
  display: inline-block;
  font-weight: 100;
  opacity: 0.7;
}
#contentTOP {
  padding-top: 40px;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}
#imgLogoTernium {
  width: auto;
  height: 49px;
  margin-bottom: 1.5em;
}
/* @media (min-width: 1024px) and (max-width: 1365px) {
  #imgLogoTernium {
    width: 98px;
    height: 34px;
  }
} */

#section1 {
  margin: 0;
  height: auto;
  width: 100%;
  background-size: cover;
}

@media (max-width: 1366px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 0.8em;
    line-height: 15px;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1365px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
  }
}
@media (min-width: 1023px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
  }
}
@media (min-width: 768px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0px;
  }
}
.spanHeader {
  font-family: "Trade Gothic LT Bold No. 2";
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  margin-left: 20px;
}

#spanPlataformaServicios {
  font-family: "Trade Gothic LT Bold No. 2";
  cursor: pointer;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
}

.initView .row {
  margin-left: 0;
  margin-right: 0;
}
.contenedorTitulosLogin {
  margin-top: 0;
  margin-bottom: 0;
  height: 500px;
  padding-left: 0;
  padding-right: 0;
  height: 77vh;
  width: 87vw;
}
@media (min-width: 1023px) {
  .contenedorTitulosLogin {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.box {
  position: relative;
  height: 67vh;
  width: 87vw;
  margin: 0;
  margin-top: 10px;
  padding: 0;
  border-style: solid;
  border-width: 0.05em;
  border-color: white;
  border-radius: 0;
}

/* @media only screen and (min-width: 1000px) {
  .box {
    margin: 0;
    margin-top: 45px;
  }
} */

.top,
.bottom,
.left,
.right {
  position: absolute;
  -webkit-animation: 8s linear;
  -moz-animation: 8s linear;
  -o-animation: 8s linear;
  animation: 8s linear;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0.5;
}

.top {
  top: 0;
  left: 0;
  height: 1px;
  -webkit-animation-name: top;
  -moz-animation-name: top;
  -o-animation-name: top;
  animation-name: top;
}
.bottom {
  bottom: 0;
  right: 0;
  height: 1px;
  -webkit-animation-name: bottom;
  -moz-animation-name: bottom;
  -o-animation-name: bottom;
  animation-name: bottom;
}
.left {
  bottom: 0;
  left: 0;
  width: 1px;
  -webkit-animation-name: left;
  -moz-animation-name: left;
  -o-animation-name: left;
  animation-name: left;
}
.right {
  top: 0;
  right: 0;
  width: 1px;
  -webkit-animation-name: right;
  -moz-animation-name: right;
  -o-animation-name: right;
  animation-name: right;
}
.contenedorTexto {
  padding-top: 80px;
  margin-bottom: 40px;
  padding-left: 5%;
  float: left;
  width: 100%;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .contenedorTexto {
    padding-top: 80px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1023px) {
  .contenedorTexto {
    padding-top: 80px;
    margin-bottom: 40px;
  }
}
@media (min-width: 992px) {
  .contenedorTexto {
    padding-top: 40px;
    margin-bottom: 20px;
  }
}
@media (min-width: 700px) {
  .contenedorTexto {
    padding-top: 40px;
    margin-bottom: 20px;
  }
}

#svgContent {
  width: 2%;
  padding: 0;
  padding-top: 6px;
}
#arrowSVG {
  fill: white;
}
.contenedorTexto2,
#svgContent {
  margin-bottom: 40px;
  padding-top: 5px;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .contenedorTexto2 {
    margin-bottom: 40px;
  }
}

h1 {
  color: white;
  font-family: "Trade Gothic LT Bold Condensed";
  font-size: 75px;
  line-height: 80px;
  letter-spacing: -1px;
}

.titleLoginContainer {
  display: block;
  position: absolute;
  right: 55%;
  width: 425px;
  bottom: 105px;
}
.contenedorLogin {
  display: block;
  position: absolute;
  background-size: cover;
  right: 13%;
  width: 425px;
  bottom: -10px;
  background-image: -o-linear-gradient(45deg, #ff3300, #ff9900);
  background-image: linear-gradient(45deg, #ff3300, #ff9900);
  padding-bottom: 2em;
}

@media (max-width: 1140px) {
  .titleLoginContainer {
    display: block;
    position: absolute;
    right: 15%;
    width: 405px;
    bottom: 280px;
    font-size: 1em !important;
  }
  .titleLoginContainer h1 {
    font-size: 4em !important;
  }
  .contenedorLogin {
    right: 23%;
  }
}
@media (max-width: 850px) {
  .titleLoginContainer h1 {
    font-size: 3.5em !important;
  }
  .titleLoginContainer {
    right: 8%;
  }
  .contenedorLogin {
    right: 20%;
  }
}
@media (max-width: 690px) {
  .titleLoginContainer {
    right: -4%;
  }
  .contenedorLogin {
    right: 11%;
  }
}
@media (max-width: 570px) {
  .titleLoginContainer {
    right: 15%;
    width: 265px;
    bottom: 280px;
    font-size: 1em !important;
  }
  .titleLoginContainer h1 {
    font-size: 3em !important;
  }
  .contenedorLogin {
    right: 10%;
    width: 370px;
  }
  #header2 {
    right: 7% !important;
  }
  #btnIngresar {
    display: block;
    position: absolute;
    right: 65% !important;
  }
}

@media (max-width: 420px) {
  .titleLoginContainer {
    right: 18%;
    width: 205px;
    bottom: 280px;
    font-size: 1em !important;
  }
  .titleLoginContainer h1 {
    font-size: 3em !important;
  }
  .contenedorLogin {
    right: 4%;
    width: 300px;
  }
  #header2 {
    right: 7% !important;
  }
  #btnIngresar {
    display: block;
    position: absolute;
    right: 60% !important;
  }
  #problemasLOGIN {
    padding-left: 3em;
  }
}

/* @media only screen and (min-width: 1224px) {
  .contenedorLogin {
    bottom: -20px;
  }
}
@media (min-width: 992px) {
  .contenedorLogin {
    bottom: -60px;
  }
}
@media (min-width: 700px) {
  .contenedorLogin {
    bottom: -20px;
  }
} */

#contentSpanIngreseCuenta {
  padding-top: 25px;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 25px;
}

#spanIngreseCuenta {
  font-family: Trade Gothic LT;
  font-size: 21px;
  color: #fff;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
}

#spanIngreseCuentaTexto {
  font-family: Trade Gothic LT;
  margin-top: 5px;
  font-size: 13px;
  color: #fff;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
}

#loginDiv {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 20px;
}

.textLoginPlaceholder {
  color: rgba(255, 255, 255, 0.9) !important;
  border-radius: 2px;
  border-top-right-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: none;
  height: 40px;
  width: 100%;
  padding: 6px 12px;
  font-family: "Trade Gothic LT Bold No. 2";
}
.textLoginPlaceholder1 {
  color: rgba(255, 255, 255, 0.9) !important;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-right: 0px;
  background: none;
  height: 40px;
  width: 88%;
  padding: 6px 12px;
  font-family: "Trade Gothic LT Bold No. 2";
}

.textLoginPlaceholder::placeholder {
  color: #fff !important;
}

.textLoginPlaceholder1::placeholder {
  color: #fff !important;
}

#btn_Mostrar_Password {
  border: 1px solid white;
  border-left: 0px;
  box-shadow: none;
  border-top-right-radius: 4px;
  color: white;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.btnFullWhite {
  height: 42px;
  border-radius: 25px;
  width: 100%;
  padding: 0px;
  background-color: white;
  color: #ff3300;
  outline: none;
  font-weight: 600;
  text-transform: uppercase;
}
.spanLinkLogin {
  font-family: "Trade Gothic LT";
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1em !important;
}
@media (max-width: 1366px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 0.8em;
    line-height: 17px;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1365px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0px;
  }
}
@media (min-width: 768px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 9px;
    line-height: 13px;
    letter-spacing: 0px;
  }
}

.contenedorMainFunctions {
  width: 100%;
  float: left;
  padding: 6%;
  background-color: #fff;
}

#spanFuncionesPrincipales {
  color: black;
  font-size: 50px;
  font-family: "Trade Gothic LT Bold Condensed";
}

.subtitulos2 {
  color: #7b7b7b;
  font-size: 18px;
  line-height: 1.39;
  font-family: "Trade Gothic LT";
}

@media (min-width: 700px) {
  .subtitulos2 {
    font-size: 18px;
  }
}

.contenedorConfiguracion {
  width: 100%;
  float: left;
  padding: 6%;
  background-color: #f6f6f6;
}

.contenedorConfiguracion h5 {
  font-family: "Trade Gothic LT Bold No. 2";
}
.contenedorConfiguracion .col-xs-4 {
  padding-left: 2em;
  padding-right: 2em;
}

@media (min-width: 1366px) and (max-width: 1920px) {
  .contenedorConfiguracion h5 {
    font-size: 45px;
    line-height: 48px;
    letter-spacing: -1.5px;
  }
}

@media (min-width: 768px) {
  .contenedorConfiguracion h5 {
    font-size: 30px;
    line-height: 30px;
    letter-spacing: -1.5px;
  }
}

.backgroundNegro {
  height: auto;
  position: relative;
  width: 100%;
  right: 0;
  float: left;
  padding: 6% 6% 11%;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
}

.ventajas {
  color: #fff;
  font-size: 45px;
  font-family: "Trade Gothic LT Bold Condensed";
}
.subtitulos {
  color: white;
  font-family: "Trade Gothic LT Bold Condensed";
  font-size: 20px;
  position: absolute;
  width: 15em;
  top: 55px;
}
.textoAdvantages {
  font-family: "Trade Gothic LT Bold Condensed";
  color: #2f3339;
  font-size: 140px;
}
.body3 {
  font-family: "Trade Gothic LT";
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  position: absolute;
  width: 15em;
  top: 95px;
}
.contenedorFooter {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
}

.contenedorFooter {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
}

.spanFooter {
  cursor: pointer;
  font-family: "Trade Gothic LT";
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
}
@media (max-width: 1366px) {
  .spanFooter {
    font-size: 0.8em;
  }
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .spanFooter {
    font-size: 15px;
  }
}
@media (min-width: 1023px) {
  .spanFooter {
    font-size: 15px;
  }
}
@media (min-width: 768px) {
  .spanFooter {
    font-size: 12px;
  }
}

.logoNegroTernium {
  width: 151.3px;
  height: 52.8px;
}
#container_login {
  text-transform: none;
}

.logoNegroTernium {
  width: 151.3px;
  height: 52.8px;
}
.logoNegroTernium {
  vertical-align: middle;
}
.logoNegroTernium {
  border: 0;
}

.cuadrosText {
  padding-right: 2em;
  padding-left: 2em;
}
.text-white {
  height: 2em;
  background-color: #fff;
}
.col-margin {
  width: 2em;
}

input:-webkit-autofill {
  -webkit-background-clip: text;
  -webkit-text-fill-color: white;
}
.justify-content-md-center {
  justify-content: center !important;
}
#textMARK {
  text-transform: none !important;
}
#problemasLOGIN {
  cursor: default;
  font-size: 1.5em;
}
#to-recover {
  text-decoration-line: underline;
}
/* .optionLoginSelector {
  background-color: #1e253300;
} */

#clienteFormControlSelect {
  background-color: rgba(34, 34, 34, 0);
  border-radius: 0 !important;
}
#clienteFormControlSelect option {
  background-color: #ff33007a;
  font-size: 1.2em;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLogin/Login/Login.vue